import type { QuillReport } from "@quillsql/react"
import { useMemo } from "react"

import { GroupLabel } from "@molecules"

import ReportChartCard from "@pages/Reports/ReportDashboard/ReportChartCard/ReportChartCard"

import styles from "./ReportSection.module.scss"
import { ReportSectionProps } from "./ReportSection.types"

function isDefined(report: QuillReport | undefined): report is QuillReport {
    return report !== undefined
}

export default function ReportSection(props: ReportSectionProps) {
    const { sectionName, reportOrder, reports, onReportClick } = props

    const orderedReports = useMemo(() => {
        return reportOrder.map((reportId) => reports.find((report) => report.id === reportId)).filter(isDefined)
    }, [reportOrder, reports])

    if (orderedReports.length === 0) {
        return null
    }

    return (
        <section className={styles.base}>
            <GroupLabel variant="primary" label={sectionName} />
            <div className={styles.chartGrid}>
                {orderedReports.map((report) => (
                    <ReportChartCard
                        key={report.id}
                        reportId={report.id}
                        reportName={report.name}
                        chartType={report.chartType}
                        showLegend={report.showLegend}
                        onClick={() => onReportClick(report.id)}
                    />
                ))}
            </div>
        </section>
    )
}
